export default __webpack_public_path__ + "static/media/core-bg3.08911baa.png";